import combine from '../services/combine-service';
import moment from 'moment';
const labor = {
  monday: null,
  sunday: null,
  confirmed: true,
  empnumber: null,
  entries: [],
  backup: []
};
export default function(state = labor, action) {
  var payload;
  switch (action.type) {
    case 'dailylaborentries - Labor':
      return {
        ...state,
        entries: action.payload,
        backup: action.payload,
        confirmed: true
      };
      break;
    case 'dailylabor params':
      return {
        ...state,
        monday: moment(action.payload.monday),
        sunday: moment(action.payload.sunday),
        empnumber: action.payload.empnumber
      };
      break;
    case 'Update > dailylaborentries':
      return {
        ...state,
        entries: combine(
          state.entries,
          action.payload,
          'id',
          action.deletestatus
        ),
        confirmed: true
      };
      break;
    case 'Feathers Update > dailylaborentries':
      if (state.empnumber) {
        var laborentries = action.payload.filter(
          entry => entry.empnumber == state.empnumber
        );
        if (laborentries.length) {
          return {
            ...state,
            entries: combine(
              state.entries,
              laborentries,
              'id',
              action.deletestatus
            ),
            confirmed: true
          };
        }
      }

      break;
    case 'local labor update':
      return { ...state, confirmed: false };
      break;
    case 'local labor canceled':
        return { ...state, confirmed: true };
        break;
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/labor-reducer.js